var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2051 5.05984V9.18484C10.2051 9.56368 9.89774 9.87234 9.51758 9.87234H2.64258C2.26374 9.87234 1.95508 9.56368 1.95508 9.18484V1.62234H6.76758L8.14258 0.247345H1.95508C1.19608 0.247345 0.580078 0.863345 0.580078 1.62234V9.18484C0.580078 10.324 1.50408 11.2473 2.64258 11.2473H9.51758C10.6574 11.2473 11.5801 10.324 11.5801 9.18484V3.68484L10.2051 5.05984ZM3.47791 8.33443L6.22791 7.64693L5.19666 6.61568L4.16541 5.58443L3.47791 8.33443ZM6.65483 7.10245L4.71058 5.15753L8.10066 1.76678L9.47697 0.391784L9.49216 0.376595C9.57675 0.290679 9.68597 0.247345 9.78916 0.247345C9.87364 0.247345 9.95549 0.277595 10.0161 0.338095L10.0697 0.391656L11.4757 1.79637C11.5403 1.86095 11.5726 1.9517 11.5644 2.05003C11.5574 2.14968 11.5113 2.24659 11.4364 2.32084L6.65483 7.10245Z",
    fill: "#6D4997"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.c7a2643806ac9e85fc564b3360a4b76d.svg";
export { ForwardRef as ReactComponent };